import React, { Component } from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import styles from './styles.scss'

import Dropdown from 'components/form/dropdown'
import Input from 'components/form/input'
import T from 'i18n-react'

import {
  projectPriorityOptionsSelector,
  productSampledOptionsSelector,
  readyForReviewOptionsSelector,
  publishToWebOptionsSelector,
  cpmNineHundredLevelPartNumberSelector,
  cpmProjectPriorityIdSelector,
  cpmProductSampledIdSelector,
  cpmReadyForReviewIdSelector,
  cpmPublishToWebIdSelector,
  cpmNotesSelector,
  prodReleaseSelector,
  generalAvailabilitySelector
} from './selectors'

import {
  updateNineHundredLevelPartNumber,
  updateProjectPriorityId,
  updateProductSampledId,
  updateReadyForReviewId,
  updatePublishToWebId,
  updateCpmNotes,
  updateProdRelease,
  updateGeneralAvailability
} from './actions';

const mapStateToProps = state => {
  return {
    nineHundredLevelPartNumber: cpmNineHundredLevelPartNumberSelector(state),
    projectPriorityId: cpmProjectPriorityIdSelector(state),
    productSampledId: cpmProductSampledIdSelector(state),
    readyForReviewId: cpmReadyForReviewIdSelector(state),
    publishToWebId: cpmPublishToWebIdSelector(state),
    cpmNotes: cpmNotesSelector(state),
    generalAvailability: generalAvailabilitySelector(state),
    prodRelease: prodReleaseSelector(state),
    projectPriorityOptions: projectPriorityOptionsSelector(state),
    productSampledOptions: productSampledOptionsSelector(state),
    readyForReviewOptions: readyForReviewOptionsSelector(state),
    publishToWebOptions: publishToWebOptionsSelector(state)
  }
}

const mapDispatchToProps = dispatch => {
  return {
    updateNineHundredLevelPartNumber: (partNumber) => dispatch(updateNineHundredLevelPartNumber(partNumber)),
    updateProjectPriorityId: (projectPriorityId) => dispatch(updateProjectPriorityId(projectPriorityId)),
    updateProductSampledId: (productSampledId) => dispatch(updateProductSampledId(productSampledId)),
    updateReadyForReviewId: (readyForReviewId) => dispatch(updateReadyForReviewId(readyForReviewId)),
    updatePublishToWebId: (publishToWebId) => dispatch(updatePublishToWebId(publishToWebId)),
    updateCpmNotes: (cpmNotes) => dispatch(updateCpmNotes(cpmNotes)),
    updateGeneralAvailability: (generalAvailability) => dispatch(updateGeneralAvailability(generalAvailability)),
    updateProdRelease: (prodRelease) => dispatch(updateProdRelease(prodRelease))
  }
}

class CpmDetailsEdit extends Component {

  render(){
    const {
      nineHundredLevelPartNumber,
      generalAvailability,
      prodRelease,
      projectPriorityId,
      productSampledId,
      readyForReviewId,
      publishToWebId,
      cpmNotes,
      projectPriorityOptions,
      productSampledOptions,
      readyForReviewOptions,
      publishToWebOptions,
      updateNineHundredLevelPartNumber,
      updateProjectPriorityId,
      updateProductSampledId,
      updateReadyForReviewId,
      updatePublishToWebId,
      updateCpmNotes,
      updateProdRelease,
      updateGeneralAvailability
    } = this.props;

    return (
      <div styleName='cpm_details_edit'>
        <Input
          styleName='user_input'
          title={T.translate('project.cpmDetails.nineHundredLevelPartNumber')}
          type='text'
          value={nineHundredLevelPartNumber}
          onChange={updateNineHundredLevelPartNumber}
        />
        <Dropdown
          styleName='user_input'
          title={T.translate('project.cpmDetails.projectPriority')}
          source={projectPriorityOptions}
          value={projectPriorityId}
          onChange={updateProjectPriorityId}
        />
        <Dropdown
          styleName='user_input'
          title={T.translate('project.cpmDetails.productSampled')}
          source={productSampledOptions}
          value={productSampledId}
          onChange={updateProductSampledId}
        />
        <Dropdown
          styleName='user_input'
          title={T.translate('project.cpmDetails.readyForReview')}
          source={readyForReviewOptions}
          value={readyForReviewId}
          onChange={updateReadyForReviewId}
        />
        <Dropdown
          styleName='user_input'
          title={T.translate('project.cpmDetails.publishToWeb')}
          source={publishToWebOptions}
          value={publishToWebId}
          onChange={updatePublishToWebId}
        />
        <Input
          styleName='user_input'
          title={T.translate('project.cpmDetails.cpmNotes')}
          type='text'
          value={cpmNotes}
          onChange={updateCpmNotes}
        />
        <Input
          styleName='user_input'
          title={T.translate('project.cpmDetails.generalAvailability')}
          type='text'
          value={generalAvailability}
          onChange={updateGeneralAvailability}
        />
        <Input
          styleName='user_input'
          title={T.translate('project.cpmDetails.prodRelease')}
          type='text'
          value={prodRelease}
          onChange={updateProdRelease}
        />
      </div>
    );
  }

}

const withStyle = CSSModules(styles)
const withConnect = connect(mapStateToProps, mapDispatchToProps)

const enhance = compose(
    withConnect,
    withStyle
)

export default enhance(CpmDetailsEdit);
